<template>
  <v-dialog
    v-model="isOpen"
    content-class="rounded-lg"
    :persistent="persistent"
    :width="width"
    :scrollable="scrollable"
    :retain-focus="false"
  >
    <section class="container-dialog" :style="{backgroundColor: bgColor}">
      <div 
        v-if="$slots.title || showCloseBtn" 
        :class="[
          'd-flex justify-space-between items-center pt-5 pb-3',
          defaultHorizontalPadding
        ]"
        :style="{backgroundColor: bgTitleColor}"
      >
        <div class="d-flex flex">
          <slot name="title"></slot>
        </div>

        <v-btn fab elevation="0" x-small class="mr-n3 mt-n1" style="background-color: #EDEDF1 !important">
          <v-icon color="bt_text" size="12" style="padding-left: 2px" @click="isOpen = false">fas fa-close</v-icon>
        </v-btn>
      </div>

      <div v-if="showTitleDivider" class="dialog-divider"></div>

      <div 
        v-if="$slots.content" 
        :class="['pt-4 my-2', {'dialog-content': !hideScrollInContent}, defaultHorizontalMarginContent]" 
        style="max-height: 70vh;"
      >
        <Container>
          <section :class="[defaultHorizontalPaddingContent]">
            <slot name="content"></slot>
          </section>
        </Container>
      </div>

      <div :class="[defaultHorizontalPadding, 'pb-4 pt-2']">
        <section v-if="$slots.actions">
          <slot name="actions"></slot>
        </section>
      </div>
    </section>
  </v-dialog>
</template>

<script>
import Container from './Container.vue'

export default {
  name: 'Dialog',
  components: { Container },
  props: {
    value: {type: Boolean, required: true},
    width: {type: String, default: '600px'},
    showTitleDivider: {type: Boolean, default: false},
    scrollable: {type: Boolean, default: true},
    showCloseBtn: {type: Boolean, default: true},
    hideScrollInContent: {type: Boolean, default: false},
    persistent: {type: Boolean, default: true},
    bgColor: {type: String, default: 'white'},
    bgTitleColor: {type: String, default: 'white'},
  },

  computed: {
    isOpen: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },

    defaultPadding () {
      return ''
    }
  },

  data: () => ({
    open: true,
    defaultHorizontalPadding: 'px-7',
    defaultHorizontalPaddingContent: 'px-3',
    defaultHorizontalMarginContent: 'mx-4',
  })
}
</script>

<style scoped>
.container-dialog {
  font-family: Inter !important;
}

.dialog-divider {
  background-color: rgba(102, 109, 128, 0.2);
  height: 1px;
  margin: 0;
}

.dialog-content {
  overflow-x: hidden;
  overflow-y: auto;
}

.dialog-content::-webkit-scrollbar {
  width: 8px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background-color: #EDEDF1;
  border-radius: 5px;
}

.dialog-content::-webkit-scrollbar-track {
  background-color: white;
}
</style>
